import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import { RiContactsBook2Fill } from "react-icons/ri";
import InputGroup from "react-bootstrap/InputGroup";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";
// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    style={{height : '100%' }}
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    {/* &#x25bc; for the arrow*/}
  </div>
));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    const [value, setValue] = useState("");
    const { language } = useLanguage();
    const pageTitle = "FormsView";
    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <Form.Control
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder= {strings[pageTitle][language].TypeMsg}
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().includes(value)
          )}
        </ul>
      </div>
    );
  }
);

function CustomDropDown({ contactList  , setParentPhoneNumber }) {
  
  return (
    <div>
      <Dropdown
        onSelect={(eventKey, b) => {
          console.log(eventKey);
          setParentPhoneNumber(eventKey)
        }}
   
      >
        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components"  >
          <InputGroup.Text id="basic-addon2"  style={{height : '100%' , borderRadius : '0 0.35em 0.35em 0' , cursor : 'pointer' }}>
            <RiContactsBook2Fill />
          </InputGroup.Text>
        </Dropdown.Toggle>

        <Dropdown.Menu as={CustomMenu}>
          {contactList?.map((contact) => {
            return (
              <Dropdown.Item eventKey={contact.phone}>
                {contact.name + " (" + contact.phone +")"} 
              </Dropdown.Item>
            );
          })}
          {/* <Dropdown.Item eventKey="1">Red</Dropdown.Item>
          <Dropdown.Item eventKey="2">Blue</Dropdown.Item>
          <Dropdown.Item eventKey="3" active>
            Orange
          </Dropdown.Item>
          <Dropdown.Item eventKey="1">Red-Orange</Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default CustomDropDown;
